module.exports = __webpack_public_path__ + "static/media/EW_0013_02.74234b59.png";